import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useViewType } from '../../../hooks/useViewType';
import { VIEW_TYPES } from '../../../constants/viewTypes';

import { Button } from '../../../design-system';
import Banner from '../../../design-system/Banner/Banner';
import CircularIcon from '../../../design-system/CircularIcon/CircularIcon';
import CheckLineIcon from '../../../design-system/Icons/CheckLineIcon';

const SubmissionSuccessState = ({ pageAction, processTemplateName, processId }) => {
    const navigate = useNavigate();

    const { viewType, toggleViewType } = useViewType();

    const title = {
        setup: 'Your new agent is ready!',
        upgrade: 'Your agent has been upgraded!',
    };

    const descriptionPart = {
        setup: 'You’ve successfully set up your new',
        upgrade: 'You’ve successfully upgraded your',
    };

    const handleViewAgent = () => {
        const url = {
            [VIEW_TYPES.admin]: `/configure/process/${processId}`,
            [VIEW_TYPES.client]: `/agent/${processId}`,
        }[viewType];
        navigate(url);
    };

    const handleViewPlaybooks = () => {
        if (viewType === VIEW_TYPES.admin) {
            toggleViewType();
        }
        navigate('/playbooks');
    };

    return (
        <div className="flex-grow px-2 py-3 sm:px-0 lg:py-5 flex flex-col gap-4">
            {pageAction === 'upgrade' && (
                <Banner
                    title="Important Note"
                    text="Your Make.com and Zapier scenarios will require a reload to continue to work with this upgraded agent!"
                    color="blue"
                />
            )}
            <div className="max-w-[460px] mx-auto flex flex-col gap-[40px]">
                <div className="flex flex-col items-center gap-4 pb-4 border-b-1 border-neutral-200">
                    <CircularIcon icon={CheckLineIcon} color="lime" />

                    <p className="font-body text-body-regular-xs text-neutral-300 uppercase">
                        Successfully {pageAction === 'upgrade' ? 'Upgraded' : 'Created'}
                    </p>
                    <p className="font-heading-bold text-heading-bold-m text-black text-center">
                        {title[pageAction]}
                    </p>
                    <p className="font-body text-body-regular-s text-neutral-400 text-center">
                        {descriptionPart[pageAction]} {processTemplateName} agent! Visit Agent
                        Details to view and edit your settings at any time.
                    </p>
                    <Button
                        type="link"
                        size="sm"
                        text="View Agent Details"
                        onClick={handleViewAgent}
                    />
                </div>
                <div className="flex flex-col gap-3">
                    <p className="font-body text-body-regular-s text-neutral-400 text-center">
                        View your current playbooks:
                    </p>
                    <div className="flex gap-2 items-center justify-center">
                        <div className="min-w-[calc((100%-8px)/2)] flex flex-col">
                            <Button
                                type="ghost"
                                size="sm"
                                text="My Playbooks"
                                onClick={handleViewPlaybooks}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubmissionSuccessState;
